@if (showStartingPrice) {
    <button
        [disabled]="startingPriceDisabled"
        [ngClass]="{ 'selected': isStartingPriceSelected, 'no-fixed-price': !isFixedPriceAvailable }"
        (click)="selectedPriceClick($event)">
        {{ messages.common.StartingPrice }}
    </button>
}
